import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import i18n from "../../../translate/i18n.jsx";

import mapaPirangi from "../../../assets/mapaPirangi.png";
import mapaRei from "../../../assets/mapaRei.png";

export default function Cajueiro() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language;
  const castanhaSlug = i18n.getFixedT(lang)("endereco.castanha");

  const irParaHistoria = () => {
    navigate(`/${lang}/${castanhaSlug}#castanha-cajueiros-section`);
  };

  return (
    <section className="cajueiros-section">
      <h1>{t("home.cajueiro.titulo")}</h1>
      <div className="flex">
        <p>{t("home.cajueiro.descricao.p1")}</p>
        <div className="cajueiro-item">
          <img src={mapaRei} alt="Imagem do mapa do Cajueiro Rei" />
          <p className="legenda">{t("home.cajueiro.legenda1")}</p>
        </div>
      </div>
      <div className="flex inverter">
        <div className="cajueiro-item">
          <img src={mapaPirangi} alt="Imagem do mapa do Cajueiro de Pirangi" />
          <p className="legenda">{t("home.cajueiro.legenda2")}</p>
        </div>
        <p>{t("home.cajueiro.descricao.p2")}</p>
      </div>
      <div className="cta-box">
        <h2>{t("home.cajueiro.botao.pergunta")}</h2>
        <button className="cta-button" onClick={irParaHistoria}>
          {t("home.cajueiro.botao.botao")}
        </button>
      </div>
    </section>
  );
}
